import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
    userCpfValidationSuccess,
    userCpfValidationFaild,
    validateUserPasswordPowerResponse,
    passwordConfirmationResponse,
    CALL_USER_CPF_VALIDATION, PASSWORD_CONFIRMATION,
} from '../ducks/inputValidations';

import * as inputValidations from '../integrations/InputValidationsAPI';
import { message } from 'antd';

function* userCpfValidation({data}) {
    const {cpf, token} = data;
    try {
        let result = yield call(inputValidations.userCpfValidation, {cpf, token});
        console.log('ressult', result)
        if (result === 'true') {
            yield put(userCpfValidationSuccess('Ok'));
        } else {
            yield put(userCpfValidationFaild('Cpf inválido ou já cadastrado'));
            message.error('Cpf inválido ou já cadastrado');
        }

    } catch(error) {
        message.error(error);
        yield put(userCpfValidationFaild(error));
    }
}

function* userCpfValidationSaga() {
    yield takeLatest(CALL_USER_CPF_VALIDATION, userCpfValidation)
}

function* userPasswordPowerValidator({password}) {
    try {
        const result = yield call(inputValidations.userPasswordValidation.init, password);
        yield put(validateUserPasswordPowerResponse(result));

    } catch(error) {
        message.error(error);
    }
}

function* passwordConfirmation({password, confirmation}) {
    try {
        console.log(password, confirmation)
        yield call(inputValidations.passwordConfirmation, {password, confirmation});
        yield put(passwordConfirmationResponse({status: 'success', message: ''}));
    } catch (error) {
        message.error(error);
        yield put(passwordConfirmationResponse({status: 'warning', message: error}));
    }
}

function* passwordConfirmationSaga() {
    yield takeLatest(PASSWORD_CONFIRMATION, passwordConfirmation)
}

export default function* rootSaga() {
    yield all([
        fork(userCpfValidationSaga),
        fork(passwordConfirmationSaga),
    ])
}





// WEBPACK FOOTER //
// ./src/sagas/inputValidationsSaga.js